import { useToast } from '@/composables/useToast';
import { endpointsList } from '@/helpers';
import axios from 'axios';
import { IValidateKKSRangeDto } from 'types';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

export function useWorkspaceKks() {
  const { createErrorToast } = useToast();
  const { t } = useI18n();

  const isLoadingKksAccess = ref(false);

  async function validateKksAccess(
    workspaceId: string,
    kks: string[],
  ): Promise<boolean> {
    try {
      isLoadingKksAccess.value = true;
      const response = await axios.post<boolean>(
        endpointsList.workspaces.areKksInWorkspaceGroupKksRange(workspaceId),
        { kks } satisfies IValidateKKSRangeDto,
      );
      return response.data;
    } catch (error) {
      createErrorToast(t('useWorkspaceKks.errors.errorCheckingKksAccess'));
      return false;
    } finally {
      isLoadingKksAccess.value = false;
    }
  }

  return { isLoadingKksAccess, validateKksAccess };
}
